import {
  ApiResponse,
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "@/data/apiClient";

export interface Term {
  title: string;
  id?: string;
  author: string;
  text: string;
}

export interface TermsAgreed {
  termsAgreed: boolean;
}

export const getTerms = async (
  app: string | undefined,
  includeParents: boolean
): Promise<ApiResponse<Term[]>> => getRequest("terms", { app, includeParents });

export const addTerm = async (
  term: Term,
  app: string
): Promise<ApiResponse<string>> => postRequest("term", { ...term, app });

export const editTerm = async (
  term: Term,
  app: string
): Promise<ApiResponse<string>> => putRequest("term", { ...term, app });

export const delTerm = async (
  term: Term,
  app: string
): Promise<ApiResponse<string>> => deleteRequest("term", { id: term.id, app });

export const updateTerms = async (
  terms: Term[],
  app: string
): Promise<ApiResponse<string>> =>
  postRequest("terms", { ids: terms.map((t) => t.id), app });

export const getTermsAgreed = async (
  app: string | undefined
): Promise<ApiResponse<TermsAgreed>> => getRequest("termsAgreed", { app });

export const setTermsAgreed = async (
  app: string,
  termsAgreed = true
): Promise<ApiResponse<string>> =>
  postRequest("termsAgreed", { app, termsAgreed });

export const deleteTermsAgreed = async (
  app: string
): Promise<ApiResponse<string>> => deleteRequest("termsAgreed", { app });
